import React from 'react'
import classNames from 'classnames'
import { useStore } from 'src/state'
import Button from 'src/components/button'
import Picture from 'src/components/picture'
import closeBtn from 'src/assets/close-btn.svg'

const TrainerCardOverlay = () => {
  const {
    trainerSettings: {
      locationTitleText,
      specialtiesTitleText,
      quoteTitleText,
    },
    isBrowser,
    trainerCardId,
    shouldShowTrainerCardOverlay,
    hideTrainerCardOverlay,
    trainers,
    windowWidth,
  } = useStore()
  const trainer = trainers.find((trainer) => trainer.id === trainerCardId)
  if (!trainer) return null
  const displayAsMobile = windowWidth < 768 && isBrowser
  const visible = shouldShowTrainerCardOverlay && displayAsMobile
  const { profilePicture, name, location, specialties, quote } = trainer
  return (
    <div className={classNames('trainer-card-overlay', visible && 'visible')}>
      <div className="trainer-card-container">
        <Button onClick={hideTrainerCardOverlay} className="close-btn">
          <Picture image={closeBtn} />
        </Button>
        <Picture
          key={trainer.id}
          className="profile-picture"
          defaultWidth={500}
          image={profilePicture}
          fitWidth
          cover
        />
        <div className="details-container">
          <div className="background-color" />
          <div className="details">
            {location && (
              <>
                <div className="label">{locationTitleText}</div>
                <p className="detail location">{location}</p>
              </>
            )}
            {specialties && (
              <>
                <div className="label">{specialtiesTitleText}</div>
                <p className="detail specialties">{specialties}</p>
              </>
            )}
            {quote && (
              <>
                <div className="label">{quoteTitleText}</div>
                <p className="detail quote">"{quote}"</p>
              </>
            )}
            <h3 className="name card-title">{name}</h3>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TrainerCardOverlay
